import * as styles from "./MenuItem.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

import { useMenuContext } from "./Menu.context";

export function MenuItem({
  className,
  ...props
}: React.ComponentProps<typeof BaseMenu.Item>): JSX.Element {
  const { size } = useMenuContext();

  return (
    <BaseMenu.Item
      data-slot="menu-item"
      className={clsx(styles.item({ size }), className)}
      {...props}
    />
  );
}
